// TODO rework tsx
import { FC } from 'react';

import { AssetCategory } from '@/entities/assets/components/AssetCategory';
import { BeneficiaryGroupI18n } from '@/entities/beneficiary/components/BeneficiaryGroupI18n';
import { ContactTypeI18n } from '@/entities/contact/components/ContactTypeI18n';
import { PidType } from '@/entities/personalIdentifiers/components/PidType';
import { PrivateDocumentCategory } from '@/entities/privateDocuments';
import { Country } from '@/shared/components';
import { AssetDto } from '@/shared/lib/sj-orm/models/asset.dto';
import { BeneficiaryDto } from '@/shared/lib/sj-orm/models/beneficiary.dto';
import { ContactDto } from '@/shared/lib/sj-orm/models/contact.dto';
import { PersonalIdentifierDocumentDto } from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';
import { PrivateDocumentDto } from '@/shared/lib/sj-orm/models/document/private.document.dto';
import { CollectionName, CollectionToDtoMap } from '@/shared/lib/sj-orm/types';

type Renderers<T> = {
  Title: FC<{ data: T }>;
  Category: FC<{ data: T }>;
  Country: FC<{ data: T }>;
};

const assetRenderers: Renderers<AssetDto> = {
  Title: ({ data }) => data.nickName || data.nickname,
  Category: ({ data }) => <AssetCategory category={data.category} />,
  Country: ({ data }) => <Country code={data.country} />,
};
const pidsRenderers: Renderers<PersonalIdentifierDocumentDto> = {
  Title: ({ data }) => data.name,
  Category: ({ data }) => <PidType type={data.personalIdentifierType} />,
  Country: ({ data }) => <Country code={data.country} />,
};
const privateDocumentsRenderers: Renderers<PrivateDocumentDto> = {
  Title: ({ data }) => data.name,
  Category: ({ data }) => <PrivateDocumentCategory category={data.privateCategory} />,
  Country: ({ data }) => <Country code={data.country} />,
};
const beneficiariesRenderers: Renderers<BeneficiaryDto> = {
  Title: ({ data }) => data.nickName,
  Category: ({ data }) => <BeneficiaryGroupI18n group={data.group} />,
  Country: ({ data }) => <Country code={data.linkedCountryCode} />, // TODO WA-2948
};
const contactsRenderers: Renderers<ContactDto> = {
  Title: ({ data }) => data.nickname,
  Category: ({ data }) => <ContactTypeI18n type={data.type} />,
  Country: ({ data }) => <Country code={data.selectedCountry} />,
};

export const itemRenderers: {
  [K in keyof CollectionToDtoMap]?: Renderers<CollectionToDtoMap[K]>;
} = {
  [CollectionName.ASSETS]: assetRenderers,
  [CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS]: pidsRenderers,
  [CollectionName.PRIVATE_DOCUMENTS]: privateDocumentsRenderers,
  [CollectionName.BENEFICIARIES]: beneficiariesRenderers,
  [CollectionName.CONTACTS]: contactsRenderers,
};
